import {Component} from "@angular/core";

@Component({
    selector: "woa-spinner",
    templateUrl: "./spinner.component.html"
})
export class SpinnerComponent {
}



// WEBPACK FOOTER //
// ./src/app/ui-elements/spinner/spinner.component.ts